
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generators/[seoTitle]/g/[generatorId]",
      function () {
        return require("private-next-pages/generators/[seoTitle]/g/[generatorId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generators/[seoTitle]/g/[generatorId]"])
      });
    }
  